import Network from '@/services/network'

export default function handleCrm(){

    const network = new Network;

    const fetchAreaList = (query) => {
        return network.api('get', `/crm/area-list` + query);
    }

    const fetchSingleArea = (id, query) => {
        return network.api('get', '/crm/area/' + id + query);
    }

    //Sales Representative
    const fetchAllSR = (query) => {
        return network.api('get', `/crm/sale-representative/all-sr` + query);
    }
    const storeSR = (data) => {
        return network.api('post', '/crm/sale-representative/store-sr', data);
    }
    const updateSr = (data, id) => {
        return network.api('put', '/crm/sale-representative/update-sr/' + id, data);
    }
    const fetchSrList = (query) => {
        return network.api('get', '/crm/sale-representative/list' + query);
    }
    const fetchSingleSr = (query, id) => {
        return network.api('get', '/crm/sale-representative/show/' + id + query);
    }
    const fetchSRDetailsByUser = (query, userId) => {
        return network.api('get', '/crm/sale-representative/get-sr-details/' + userId + query);
    }
    
    //Dealers
    const fetchAllDealers = (query) => {
        return network.api('get', `/crm/dealer/all-dealers` + query);
    }
    const fetchDealerList = (query) => {
        return network.api('get', '/crm/dealer/list' + query);
    }
    const storeDealer = (data) => {
        return network.api('post', '/crm/dealer/store-dealer', data);
    }
    const updateDealer = (data, id) => {
        return network.api('put', '/crm/dealer/update-dealer/' + id, data);
    }
    const fetchSingleDealer = (query, id) => {
        return network.api('get', '/crm/dealer/show/' + id + query);
    }
    const uploadDealers = (data) => {
        return network.api('post', '/crm/dealer/upload-dealers', data);
    }
    const insertDealers = (data) => {
        return network.api('post', '/crm/dealer/final-dealer-upload', data);
    }

    //Area
    const uploadAreas = (data) => {
        return network.api('post', '/crm/area/upload-areas', data);
    }
    const insertAreas = (data) => {
        return network.api('post', '/crm/area/final-area-upload', data);
    }

    //Visit Plan Schedule
    const storeVisitPlan = (data) => {
        return network.api('post', '/crm/visit-plan/store-visit-plan', data);
    }
    const updateVisitPlan = (data, id) => {
        return network.api('put', '/crm/visit-plan/update-visit-plan/' + id, data);
    }
    const updatePlanStatus = (data, id) => {
        return network.api('put', '/crm/visit-plan/update-visit-status/' + id, data);
    }
    const fetchVisitPlanList = (query) => {
        return network.api('get', '/crm/visit-plan/list' + query);
    }
    const fetchPlanActivity = (query) => {
        return network.api('get', '/crm/visit-plan/plan-activity' + query);
    }
    const fetchSingleVisitPlan = (query, id) => {
        return network.api('get', '/crm/visit-plan/show/' + id + query);
    }
    const fetchVisitStatus = (query) => {
        return network.api('get', '/crm/visit-plan/visit-status' + query);
    }
    const fetchClientVisitStatus = (query) => {
        return network.api('get', '/crm/visit-plan/client-status' + query);
    }

    //Visit Status
    const fetchVisitClientList = (query, id) => {
        return network.api('get', '/crm/visit-status/visit-clients/' + id + query);
    }
    const fetchBankVisitClientList = (query, dealerId) => {
        return network.api('get', '/crm/visit-status/bank-visit-clients/' + dealerId + query);
    }
    const fetchActivityLogStatus = (query) => {
        return network.api('get', '/crm/visit-status/log-status' + query);
    }
    const updateVisitStatus = (data, id) => {
        return network.api('put', '/crm/visit-status/update-visit-status/' + id, data);
    }
    const storeVisitPlanLog = (data) => {
        return network.api('post', '/crm/visit-status/store-visit-log', data);
    }
    const updateVisitPlanLog = (data, id) => {
        return network.api('put', '/crm/visit-status/update-visit-log/' + id, data);
    }

    return {
        fetchAreaList,
        fetchSingleArea,

        //Sales Representative
        fetchAllSR,
        storeSR,
        updateSr,
        fetchSrList,
        fetchSingleSr,
        fetchSRDetailsByUser,

        //Dealer
        fetchAllDealers,
        fetchDealerList,
        storeDealer,
        updateDealer,
        fetchSingleDealer,
        uploadDealers,
        insertDealers,

        //Area
        uploadAreas,
        insertAreas,

        //Visit Plan Schedule
        storeVisitPlan,
        updateVisitPlan,
        updatePlanStatus,
        fetchVisitPlanList,
        fetchPlanActivity,
        fetchSingleVisitPlan,
        fetchVisitStatus,
        fetchClientVisitStatus,

        //Visit Status
        fetchVisitClientList,
        fetchBankVisitClientList,
        updateVisitStatus,
        fetchActivityLogStatus,
        storeVisitPlanLog,
        updateVisitPlanLog
    }
}